import { useSnapshot } from "valtio"
import { configStore, contractsStore, entityStore, loginStore, bookingsStore, EntityV2Store, AgmodalStore } from "../state/CommonState"
import { $c, $cr } from '../components/AgComponents'
import EntityApi from "../state/entity-api"
import { Fragment, useEffect, useState } from "react"
import LCLScheduleCompv3 from "./LCLScheduleComp-v3"
import deleteicon from "../assets/images/deletei.svg";
import { commodityList, hazardousList } from "../StaticData"
import { Agyesno } from "../components/Agyesno"
import FCLScheduleCompv3 from "./FCLScheduleComp-v3"
import AirScheduleCompv3 from "./AirScheduleComp-v3"
import { DummySchedulev3 } from "./dummy-schedule-v3"
import LCLPricingSchedule from "../pricing/lcl.schedule"
import AirPricingSchedule from "../pricing/air.schedule"
import BranchApi from "../state/branch-api"
import EntityV2Api from "../state/entities-api"
import ShipperApi from "../state/shipper-api"
import { taskStore } from "../mytasks/task-store"
import Utils from "../util/Utils"
import BookingsApi from "../state/bookings-api"
import { loader } from "../util/loader"
import { AgCustomFile } from "../components/AgFile"
import { Col8, Cols } from "../Controls"
import on from './../components/on.png'
import off from './../components/off.png'
import MonApi, { UPDATE_BOOKING_DATA_BY_ID_URI, UPDATE_BOOKING_FIELDS_URI } from '../state/mongo-api';
import TenantUtils from "../util/tenant.utils"
import InternalV3 from "./Internal-v3"
import { DEFAULT_INVOICE_FORM, PERMISSIONS_NEW, SHIPMENT_TYPE } from "../util/constants"
import InvoiceForm from "../mytasks/InvoiceForm"
import ChargesErp from "../mytasks/ChargesErp"
import RoleUtils from "../util/RoleUtils"
import { useFieldArray, useForm } from "react-hook-form"
import LabeledSelectField from "../mui-components/LabeledSelectField"
import LabeledTextField from "../mui-components/LabeledTextField"
import { BlLadingForm } from "../components/dashboard/blLadingForm"
import { ShippingDetailsForm } from "./ShippingDetailsForm"
import { ContainerDetailsForm } from "./ContainerDetailsForm";

export default function CarrierWebView1v3(props) {
    console.log('INSIDE CARRIER WEBVIEW', props.showbooking)
    const [space, setSpace] = useState('')
    const [companyName, setCompanyName] = useState('')
    const [selectedItems, setSelectedItems] = useState([]);
    useSnapshot(loginStore)
    useSnapshot(bookingsStore)
    useSnapshot(contractsStore)
    useSnapshot(configStore)
    useSnapshot(entityStore)
    let brec = bookingsStore.current
    const aguser = loginStore.userRec.aguserRec
    useEffect(() => {
        if(brec.hsn){
            setSelectedItems(brec.hsn)
        }
        EntityApi.getList()
        const ent = entityStore.list.filter(e1 => e1.gst === brec.company)
        if (ent.length > 0) {
            let entity = ent[0]
            setCompanyName(entity.entityName)
            setSpace( space === '' ? ' ' : '')
        }else{
            setCompanyName(brec.company)
        }
    }, [ bookingsStore.current])
    if (!brec) return <></>
    if (!brec.contract) return <></>
    console.log('GOT HERE ############################', brec.contract._id)
    contractsStore.current = brec.contract
    const domain = loginStore.email.split('@')[1]

    let title = 'Carrier Web Form'

    const entity1 = entityStore.entityRec
    const renderLink = (fileName) => {
        if (fileName && fileName.length > 3) {
            return (
                <a href={process.env.REACT_APP_FILE_SERVER + '/clientfiles/' + fileName} target="_blank">{fileName}</a>
            )
        } else return <></>
    }
    const filecat = '' + Date.now()
    const enableMBL = () => (contractsStore.current.shipmentType.indexOf('FCL') >= 0
        && contractsStore.current.shipmentScope.endsWith('ort')) ? {} : { disabled: 1 }
    let commList = commodityList
    if (brec.contract.hazardous === 'Yes') commList = hazardousList
    const stype = () => brec.contract.shipmentType.toUpperCase().substr(0, 3)
    console.log('==============FROM INSIDE CARRIERWEBVIEW', brec.contract.shipmentType.toUpperCase().substr(0, 3))
    let showbooking = {}
    if (props.showbooking === '1') showbooking = {showbooking: '1'}
    let Lclschedulecomponent = LCLScheduleCompv3
    let Airschedulecomponent = AirScheduleCompv3
    if (bookingsStore.current.createdFromPricing){
        if(stype()=="LCL"){
            Lclschedulecomponent = LCLPricingSchedule
        }
        if(stype()=="AIR"){
            Airschedulecomponent = AirPricingSchedule
        }
    } 
    console.log('\n\n\nfrompricing=', bookingsStore.current.createdFromPricing, '***\n\n')
    if(brec.fba==undefined){
        brec.fba = 'No'
    }
    return (
        <div style={{ fontSize: '0.8rem' }}>
            {
                bookingsStore.current?.hasToShowDummySchedule ? <DummySchedulev3 stype={stype()} viewonly={true} />
                : stype() === 'LCL' ?
                    <Lclschedulecomponent data={bookingsStore.current.schedule} viewonly={true} {...showbooking} nobutton={true}/> :
                    stype() === 'FCL' ?
                        <FCLScheduleCompv3 data={bookingsStore.current.schedule} viewonly={true} {...showbooking}/> :
                        <Airschedulecomponent viewonly={true} {...showbooking}/>
            }

            <div className="columns">
                <$cr n='2'>First Name{space}</$cr>
                <$c n='3'>
                    {brec.firstName}
                </$c>
                <$cr n='2'>Last Name</$cr>
                <$c n='3'>
                    {brec.lastName}
                </$c>
            </div>
            <div className="columns">
                <$cr n='2'>Email ID</$cr>
                <$c n='3'>
                    {brec.emailid}
                </$c>
                <$cr n='2'>Contact Number</$cr>
                <$c n='3'>
                    {brec.phone}
                </$c>
            </div>
            <div className="columns">
                <$cr n='2'>Shipper Name</$cr>
                <$c n='3'>
                    {companyName}
                </$c>
                <$cr n='2'>Address</$cr>
                <$c n='3'>
                    {brec.address}
                </$c>
            </div>
            <div className="columns is-narrow">
                <$cr n='2'>PIN/ZIP Code</$cr>
                <$c n='3'>
                    {brec.pin}
                </$c>
                <$cr n='2'>Country</$cr>
                <$c n='3'>
                    {brec.country}
                </$c>
            </div>

            <div className="columns">
                <$cr n='2'>Incoterms</$cr>
                <$c n='3'>
                    {brec.incoTerms}
                </$c>
                <$cr n='2'>Commodity Type</$cr>
                <$c n='3'>
                    {brec.commodityType}
                </$c>
            </div>
            <div className="columns">
            {selectedItems.length ?(
            <>
                    <$cr n= '2'>HSN Code</$cr>
                        <$c>
                        <div
                    className="selected-tags"
                    style={{
                        display: "flex",
                        flexWrap: "wrap", 
                        gap: "5px",
                        width: "100%", 
                        maxWidth: "100%", 
                        overflow: "hidden",
                        boxSizing: "border-box",
                    }}
                    >
                    {selectedItems.map((item) => (
                        <div
                        key={item.id}
                        className="tag"
                        style={{
                            display: "flex",
                            alignItems: "center",
                            background: "#e0e0e0",
                            borderRadius: "20px",
                            fontSize: "14px",
                            padding: "8px 12px", 
                            maxWidth: "200px", 
                            whiteSpace: "nowrap", 
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            boxSizing: "border-box",
                            justifyContent: "flex-start",
                        }}
                        title={`${item.commodityDescription} (${item.commodityTypeName})`} // Tooltip for full text
                        >
                        <span style={{ flex: "1" }}>
                            {item.commodityDescription} ({item.commodityTypeName})
                        </span>
                        </div>
                    ))} 
                    </div>
                    </$c>
                    </>):<></>}
                    {brec.blType &&  !contractsStore.current.shipmentType.toLowerCase().includes('air')(<>
                    <$cr n='2'>BL Type</$cr>
                    <$c n='6'>
                        {brec.blType}
                    </$c></>)}
                    </div>
            {/* <div className="columns is-narrow">      
                <$cr n='2'>FBA</$cr>       
                <$c n='2'>
                    <Agyesno disabled={true} label='' record={brec} name='fba' />
                </$c>
                <$c n='8'>
                </$c>
            </div> */}
            <div className="columns is-narrow">
                <$cr n='2'>Special Instructions</$cr>
                <$c n='6'>
                    {brec.specialInstructions}
                </$c>
                <$c n='2'>
                    {
                        // (enableMBL().disabled)
                         (contractsStore.current.shipmentType.toLowerCase().includes('fcl') 
                         && contractsStore.current.shipmentScope.endsWith('ort')) ?
                            <Agyesno disabled={true} label='Do you require a Direct Carrier MBL?'
                                record={brec} name='carrierMBL' /> : null
                    }
                </$c>
            </div>

            <div className="columns">
                <$c n='1'></$c>
                <$c n='9'>
                    <div className="table-container ">
                        <table className="table is-fullwidth is-bordered is-striped is-narrow is-hoverable ">
                            <thead>
                                <tr>
                                    <th style={{ width: '16rem' }}>Required Documents</th>
                                    <th>Document Uploaded</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    bookingsStore.current?.commercialInvoice_filename_list?.length > 0 &&  (<tr>
                                        <td>Commercial Invoice</td>
                                        <td>{ brec.commercialInvoice_filename_list.map(renderLink).map(link => <>{link}<br/></>)}</td>
                                    </tr>)
                                }   
                                   {
                                        bookingsStore.current?.packingList_filename_list?.length > 0  &&
                                            <tr>
                                                <td>Packing List</td>
                                                <td>{brec.packingList_filename_list.map(renderLink).map(link => <>{link}<br/></>)}</td>
                                                </tr>  
                                    }
                                     {
                                    bookingsStore.current?.custbookingconf_filename_list?.length > 0 && (contractsStore.current.shipmentType.toLowerCase().includes('fcl') || contractsStore.current.shipmentType.toLowerCase().includes('lcl')) &&
                                    <tr>
                                        <td>Customer Booking Confirmation</td>
                                        <td>{brec.custbookingconf_filename_list.map(renderLink).map(link => <>{link}<br /></>)}</td>
                                    </tr>
                                }
                                {
                                    (
                                        (brec.commodityType && brec.commodityType.startsWith('Non-Hazardous Chemicals'))
                                        || (brec.contract.hazardous === 'Yes')
                                    ) ?
                                        <tr>
                                            <td>MSDS</td>
                                            <td>{renderLink(brec.msds_filename)}</td>
                                        </tr>
                                        : <></>
                                }
                                {
                                    (brec.commodityType && brec.commodityType.startsWith('Non-Hazardous Chemicals')) ?
                                        <tr>
                                            <td>Non-DG Declaration</td>
                                            <td>{renderLink(brec.nondgdecl_filename)}</td>
                                        </tr> : <></>
                                }
                                {
                                    (brec.contract.hazardous === 'Yes') ?
                                        <>
                                            <tr>
                                                <td>DG Declaration</td>
                                                <td>{renderLink(brec.dgdecl_filename)}</td>
                                            </tr>
                                            <tr>
                                                <td>IIP Certificate</td>
                                                <td>{renderLink(brec.iipcert_filename)}</td>
                                            </tr>
                                        </> : <></>
                                }
                                {
                                    bookingsStore.current?.shippingBill_filename_list?.length > 0 && (
                                        <tr>
                                            <td>Shipping Bill</td>
                                            <td>{brec.shippingBill_filename_list.map(renderLink).map(link => <>{link}<br /></>)}</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                </$c>
            </div>

        </div>
    )
}

export function CarrierWebView2v3(props) {
    console.log('INSIDE CARRIER WEBVIEW', props.showbooking)
    const [space, setSpace] = useState('')
    const [companyName, setCompanyName] = useState('')
    const [branchName, setBranchName] = useState('')
    const [merchantID, setMerchantID] = useState('')
    const [fbaDetails, setFbaDetails] = useState([])
    const [fbaupdatecheck, setFbaupdatecheck] = useState(1)
    const [cecOc, setCecOc] = useState(null)
    const [cecOd, setCecOd] = useState(null)
    const [shipperSearch, setShipperSearch] = useState('')
     const [invoiceReq, setInvoiceReq] = useState(false)
    const [chargesErpReq, setChargesErpReq] = useState(false)
    const [selectedItems, setSelectedItems] = useState([]);
    const [faberror,setFbaerror] = useState([])
    const [shipperDetails, setShipperDetails] = useState({ _id: "", firstName: "", lastName: "", emailId: "", mobileNumber: "", companyName: "", address: "", pincode: "", country: "", role: "", city: "", state: "", newShipper: false })
  const [invoiceData, setInvoiceData] = useState(DEFAULT_INVOICE_FORM);
    const [isNomination, setIsNomination] = useState(false)
    const [cargovalsave ,setCargovalsave] = useState(false)
        const [cargoval ,setCargoval] = useState('')
        const [cargovalcur ,setCargovalcur] = useState('USD')
    useSnapshot(loginStore)
    useSnapshot(bookingsStore)
    useSnapshot(contractsStore)
    useSnapshot(configStore)
    useSnapshot(entityStore)
    useSnapshot(taskStore)
    let brec = bookingsStore.current
    console.log("brec===============>", brec.fba)
    console.log("brec===============> fbaDetails", fbaDetails)
    let task = taskStore.current
    const [data, setData] = useState({
          commercialInvoiceList: brec?.commercialInvoiceList?brec?.commercialInvoiceList: [],
          packingList:brec?.packingList?brec?.packingList:[],
          carrierReleaseOrderList: brec?.carrierReleaseOrderList|| [],
          blDraftList: brec?.blDraftList|| [],
          finalAWBList: brec?.finalAWBList|| [],
          awbDraftList: brec?.awbDraftList|| [],
          finalBlList: brec?.finalBlList|| [],
          freightInvoiceList: brec?.freightInvoiceList|| [],
          customsTaxesDutiesList: brec?.customsTaxesDutiesList|| [],
          localChargesInvoiceList: brec?.localChargesInvoiceList|| [],
          carrierDraftList: brec?.carrierDraftList || [],
          carrierFinalList: brec?.carrierFinalList || [],
          carrierInvoicesList: brec?.carrierInvoicesList || [],
          vendorInvoicesList: brec?.vendorInvoicesList || [],
          supportingsList: brec?.supportingsList || [],
          podList: brec?.podList|| [],
          deliveryOrderList:brec?.deliveryOrderList|| [],
          measurementSlipList:brec?.measurementSlipList|| [],
          shippingInstructionList:brec?.shippingInstructionList||[],
          shippingBill_filename_list: brec?.shippingBill_filename_list || []
        });
    if(branchName.length==0){
        loader.show()
    }else{
        loader.hide()
    }
    useEffect(() => {
        if(brec.hsn){
            setSelectedItems(brec.hsn)
        }
        if(brec.contract){
        setCecOc(brec.country === (brec.contract.shipmentType.toLowerCase().includes('air') ?
        Utils.extractCountry(brec.contract.originAirport)
        : Utils.extractCountry(brec.contract.portOfReceipt)));
        setCecOd(brec.country === Utils.extractCountry(brec.contract?.finalPlaceOfDelivery));
        task["newShipper"] = false
        const fetchShipperData = async () => {
            if (brec.contract?.shipperConsigneeId) {
                try {
                    const shipperData = await ShipperApi.getShipperById(brec.contract.shipperConsigneeId);
                    setShipperDetails(shipperData.data[0]);
                    setShipperSearch(shipperData.data[0].companyName);
                } catch (error) {
                    console.error(error);
                }
            }

        };
        if (cecOc) { task["expName"] = brec.company }
        if (cecOd) { task["impName"] = brec.company }
        cecOc ? task['role'] = "imp" : task['role'] = "exp"

        fetchShipperData();
        }
    }, [brec.contract?.shipperConsigneeId, cecOc, cecOd, brec.contract, brec.country, task, brec.company]);

    useEffect(()=>{

        if(brec.cargoval==undefined || brec.cargoval.toString().trim().length==0 || Utils.toNum(brec.cargoval.trim())==0){
            setCargovalsave(true)
        }else{
            if(cargovalsave){
                setCargovalsave(false)
            }
        }
        if(merchantID!=brec.merchantID){
            setMerchantID(brec.merchantID)
        }
        if(JSON.stringify(fbaDetails)!=JSON.stringify(brec.fbaDetails)){
            setFbaDetails(brec.fbaDetails)
        }
    },[brec])
    const updatefba = (f,msg) =>{
        let e = []
        if(merchantID.length>14){
            configStore.setModalMessage(`Merchant ID 14 characters Only.`);
            e.push("merchantID")
        }
        for (let i = 0; i < f.length; i++) {
            for (let j = 0; j < f[i].length; j++) {
                if(process.env.REACT_APP_FBA_Mandatory != undefined && process.env.REACT_APP_FBA_Mandatory=='yes'){
                    if(f[i][j].fbaID?.length==0){
                        configStore.setModalMessage(`FC ID is required and cannot be left blank.`);
                        e.push("fbaID"+i+j)
                    }
                    
                    if(f[i][j].purchaseOrderID?.length==0 && brec.contract.warehouse === 'AMAZON'){
                        configStore.setModalMessage(`Amazon Reference ID is required and cannot be left blank.`);
                        e.push("purchaseOrderID"+i+j)
                    }
                    if(f[i][j].poExpiryDate== undefined || f[i][j].poExpiryDate?.length==0){
                        configStore.setModalMessage(`PO Issuance Date is required and cannot be left blank.`);
                        e.push("poExpiryDate"+i+j)
                    }
                }
                // if(f[i][j].fbaID?.length>12){
                //     configStore.setModalMessage(`FBA ID Maximum 12 characters Only.`);
                //     e.push("fbaID"+i+j)
                // }
                if(f[i][j].purchaseOrderID?.length>8){
                    configStore.setModalMessage(`Amazon Reference ID Maximum 8 characters Only.`);
                    e.push("purchaseOrderID"+i+j)
                }
            }
        }
        if(JSON.stringify(e)!=JSON.stringify(faberror)){
            setFbaerror(e)
        }
        if(e.length==0){
            let l = false
            if(brec.merchantID!=merchantID){
                l = true
            }
            if(JSON.stringify(f)!=JSON.stringify(brec.fbaDetails)){
                l = true
            }
            if(l){
                BookingsApi.setfbadetailsBooking(bookingsStore.current._id,f,merchantID,msg)
                brec.fbaDetails = JSON.parse(JSON.stringify(f))
                brec.merchantID = merchantID
            }
        }
    }
    useEffect(()=>{
        if(fbaupdatecheck!=1){
            updatefba(fbaDetails,true)
        }
    },[fbaupdatecheck])


    const aguser = loginStore.userRec.aguserRec
    useEffect(() => {
        // EntityApi.getList()
        // const ent = EntityV2Store.list.filter(e1 => e1.entityId === brec.entityId)
        if (loginStore.isClient()) {
            EntityV2Api.viewEntity(brec.entityId, (data) => {
                if (data) {
                    let entity = data
                    setCompanyName(brec.company)
                    BranchApi.viewBranch(brec.branchId, (data) => {
                        if (data.data) {
                            setBranchName(`${data.data.state?.split("/")[0]} - ${(data.data.gst.length > 0 ? data.data.gst : data.data.tinNum)}`)
                        }
                    })
                    setSpace(space === '' ? ' ' : '')

                } else {
                    setCompanyName(brec.company)
                }
            })
        } else {
            loader.show()
            EntityApi.getList()
            const ent = EntityV2Store.list.filter(e1 => e1.entityId === brec.entityId)
            if (ent.length > 0) {
                let entity = ent[0]
                setCompanyName(brec.company)
                BranchApi.viewBranch(brec.branchId, (data) => {
                    if (data.data) {
                        setBranchName(`${data.data.state?.split("/")[0]} - ${(data.data.gst.length > 0 ? data.data.gst : data.data.tinNum)}`)
                    }
                    loader.hide()
                })
                setSpace(space === '' ? ' ' : '')
            } else {
                setCompanyName(brec.company)
                loader.hide()
            }
        }

    }, [bookingsStore.current])
    if (!brec) return <></>
    if (!brec.contract) return <></>
    console.log('GOT HERE ############################', brec.contract._id, brec)
    contractsStore.current = brec.contract

    const renderLink = (fileName) => {
        if (fileName && fileName.length > 3) {
            return (
                <a href={process.env.REACT_APP_FILE_SERVER + '/clientfiles/' + fileName} target="_blank">{fileName}</a>
            )
        } else return <></>
    }

    let commList = commodityList
    if (brec.contract.hazardous === 'Yes') commList = hazardousList
    const stype = () => brec.contract.shipmentType.toUpperCase().substr(0, 3)
    console.log('==============FROM INSIDE CARRIERWEBVIEW', brec.contract.shipmentType.toUpperCase().substr(0, 3))
    let showbooking = {}
    if (props.showbooking === '1') showbooking = { showbooking: '1' }
    let Lclschedulecomponent = LCLScheduleCompv3
    let Airschedulecomponent = AirScheduleCompv3
    if (bookingsStore.current.createdFromPricing) {
        if (stype() == "LCL") {
            Lclschedulecomponent = LCLPricingSchedule
        }
        if (stype() == "AIR") {
            Airschedulecomponent = AirPricingSchedule
        }
    }
    console.log('\n\n\nfrompricing=', bookingsStore.current.createdFromPricing, '***\n\n')
    if(brec.fba==undefined){
        brec.fba = 'No'
    }

    const delFile = (a,ind)=>{
        let l = []
        for (let i = 0; i < a.length; i++) {
            if(i!=ind){
                l.push(a[i])
            }
        }
        return l
    }
    const delfba = (ind1,ind2,fbaDetails) => {
        let l = JSON.parse(JSON.stringify(fbaDetails))
        let k = []
        for (let i = 0; i < l.length; i++) {
            let k1 = []
            if(i==ind1){
                for (let j = 0; j < l[i].length; j++) {
                    if(j!=ind2){
                        k1.push(l[i][j])
                    }
                }
                k.push(k1)
            }else{
                k.push(l[i])
            }
        }
        setFbaDetails(JSON.parse(JSON.stringify(k)))
        //updatefba(k,false)
    }
    const filecat = '' + Date.now()

    const updateKey = (key, value) => {
      setData(prev => ({
        ...prev,
        [key]: [...prev[key], value], 
      }));
    };

    const removeKey = (key, indexToRemove) => {
      setData(prev => ({
        ...prev,
        [key]: prev[key].filter((_, idx) => idx !== indexToRemove)
      }));
    };

   const renderData = {
  shipperName:
    (cecOc || brec.flexiBooking)
      ? brec.shipperCompany || (!brec.flexiBooking && companyName)
      : shipperDetails.companyName,

  shipperFirstName:
    (cecOc || brec.flexiBooking)
      ? brec.shipperFirstName || brec.firstName
      : shipperDetails.firstName,

  shipperLastName:
    (cecOc || brec.flexiBooking)
      ? brec.shipperLastName || brec.lastName
      : shipperDetails.lastName,

  shipperEmail:
    (cecOc || brec.flexiBooking)
      ? brec.shipperEmailid || brec.emailid
      : shipperDetails.emailId,

  shipperContact:
    (cecOc || brec.flexiBooking)
      ? brec.shipperPhone || brec.phone
      : shipperDetails.mobileNumber,

  shipperAddress:
    (cecOc || brec.flexiBooking)
      ? brec.shipperAddress || brec.address
      : shipperDetails.address,

  shipperCity:
    (cecOc || brec.flexiBooking)
      ? brec.shipperCity || brec.city
      : shipperDetails.city,

  shipperState:
    (cecOc || brec.flexiBooking)
      ? brec.shipperState || brec.state
      : shipperDetails.state,

  shipperZip:
    (cecOc || brec.flexiBooking)
      ? brec.shipperPin || brec.pin
      : shipperDetails.pincode,

  shipperCountry:
    (cecOc || brec.flexiBooking)
      ? brec.shipperCountry || brec.country
      : shipperDetails.country,

  shipperContactPerson:
    (cecOc || brec.flexiBooking)
      ? `${brec.shipperFirstName || brec.firstName || ""} ${brec.shipperLastName || brec.lastName || ""}`
      : `${shipperDetails.firstName || ""} ${shipperDetails.lastName || ""}`,

  consigneeName:
    (cecOd && !brec.flexiBooking)
      ? companyName || brec.company
      : shipperDetails.companyName,

  consigneeFirstName:
    (cecOd && !brec.flexiBooking)
      ? brec.firstName
      : shipperDetails.firstName,

  consigneeLastName:
    (cecOd && !brec.flexiBooking)
      ? brec.lastName
      : shipperDetails.lastName,

  consigneeEmail:
    (cecOd && !brec.flexiBooking)
      ? brec.emailid
      : shipperDetails.emailId,

  consigneeContact:
    (cecOd && !brec.flexiBooking)
      ? brec.phone
      : shipperDetails.mobileNumber,

  consigneeAddress:
    (cecOd && !brec.flexiBooking)
      ? brec.address
      : shipperDetails.address,

  consigneeCity:
    (cecOd && !brec.flexiBooking)
      ? brec.city
      : shipperDetails.city,

  consigneeState:
    (cecOd && !brec.flexiBooking)
      ? brec.state
      : shipperDetails.state,

  consigneeZip:
    (cecOd && !brec.flexiBooking)
      ? brec.pin
      : shipperDetails.pincode,

  consigneeCountry:
    (cecOd && !brec.flexiBooking)
      ? brec.country
      : shipperDetails.country,

  consigneeContactPerson:
    (cecOd && !brec.flexiBooking)
      ? `${brec.firstName || ""} ${brec.lastName || ""}`
      : `${shipperDetails.firstName || ""} ${shipperDetails.lastName || ""}`,
    
};



    
    brec.commercialInvoiceList = brec.commercialInvoiceList?brec.commercialInvoiceList:[]
    brec.packingList = brec.packingList?brec.packingList:[]
    brec.carrierReleaseOrderList=brec.carrierReleaseOrderList?brec.carrierReleaseOrderList : []
    brec.blDraftList=brec.blDraftList?brec.blDraftList:[]
    brec.finalAWBList=brec.finalAWBList?brec.finalAWBList:[]
    brec.awbDraftList=brec.awbDraftList?brec.awbDraftList:[]
    brec.finalBlList=brec.finalBlList?brec.finalBlList:[]
    brec.freightInvoiceList=brec.freightInvoiceList?brec.freightInvoiceList:[]
    brec.customsTaxesDutiesList=brec.customsTaxesDutiesList?brec.customsTaxesDutiesList:[]
    brec.localChargesInvoiceList=brec.localChargesInvoiceList?brec.localChargesInvoiceList:[]
    brec.carrierDraftList = brec?.carrierDraftList ? brec?.carrierDraftList : []
    brec.carrierFinalList = brec?.carrierFinalList ? brec?.carrierFinalList: []
    brec.carrierInvoicesList = brec?.carrierInvoicesList ? brec?.carrierInvoicesList :[]
    brec.vendorInvoicesList = brec?.vendorInvoicesList ? brec?.vendorInvoicesList: []
    brec.supportingsList= brec?.supportingsList ? brec?.supportingsList: []
    brec.podList=brec.podList?brec.podList:[]
    brec.deliveryOrderList=brec.deliveryOrderList?brec.deliveryOrderList:[]
    brec.measurementSlipList=brec.measurementSlipList?brec.measurementSlipList:[]
    brec.shippingInstructionList = brec.shippingInstructionList?brec.shippingInstructionList:[]

    let enterpriseCheck = brec?.Entities?.customer?.crossBorder?.salesVertical!='MSME'
    const carrierDocumentRows = [
        { id: 'cwf14', label: 'Carrier Draft', key: 'carrierDraftList', filetype: 'carrierDraftList' },
        { id: 'cwf15', label: 'Carrier Final', key: 'carrierFinalList', filetype: 'carrierFinalList' },
        { id: 'cwf16', label: 'Vendor Invoices', key: 'vendorInvoicesList', filetype: 'vendorInvoicesList' },
        { id: 'cwf17', label: 'Carrier Invoice', key: 'carrierInvoicesList', filetype: 'carrierInvoicesList' },
        { id: 'cwf18', label: 'Supportings', key: 'supportingsList', filetype: 'supportingsList' },
        { id: 'cwf19', label: 'Shipping Bill', key: 'shippingBill_filename_list', filetype: 'shippingBill_filename_list' },
    ]
      const handleInvoice = () => setInvoiceReq(prev => !prev);


    let tradeType = Utils.getTradeType({
        rec: brec.contract,
        shipmentType: brec.contract.shipmentType,
        entityCountry: EntityV2Store.EntityRec.entityCountry
    })
    let rmList = EntityV2Store.EntityRec.customer.crossBorder.relationshipManagers
    let csList = EntityV2Store.EntityRec.customer.crossBorder.customerService
    let rmemails = Utils.getRelationShipMangerForType(rmList, brec.contract.shipmentType, tradeType);
    let csemails = Utils.getCustomerServiceForType(csList, brec.contract.shipmentType, tradeType);

    if (configStore.shippingDetails) return <ShippingDetailsForm />
    if (configStore.containerDetails) return <ContainerDetailsForm />
    if(configStore.blDetails) return <BlLadingForm />
    const finalDelivery = bookingsStore.current.contract.portOfReceipt?.toLowerCase()
    const buttonCondition = finalDelivery.includes('india')
    const shipmentType = bookingsStore.current.contract?.shipmentType?.toLowerCase()
    return (
        <div style={{ backgroundColor: "white", fontSize: '0.8rem' }}>
            <ProceedPopup data={data} bookingNum={brec._id}/>
            {
                bookingsStore.current?.hasToShowDummySchedule ? <DummySchedulev3 showbooking={props.showbooking} stype={stype()} viewonly={true} />
                    : stype() === 'LCL' ?
                        <Lclschedulecomponent data={bookingsStore.current.schedule} viewonly={true} {...showbooking} nobutton={true} /> :
                        stype() === 'FCL' ?
                            <FCLScheduleCompv3 data={bookingsStore.current.schedule} viewonly={true} {...showbooking} /> :
                            <Airschedulecomponent viewonly={true} {...showbooking} />
            }
            <InternalV3 autosave={false}/>
            <div>
                <div style={{ display: 'flex', paddingTop: "20px" ,gap:'10px'}}>
                {(RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.PARTY_DETAILS) && bookingsStore.current.contract?.shipmentType != SHIPMENT_TYPE.air) &&
                <div>
  <button
    className="button is-link is-small"
    onClick={() => 
        setInvoiceReq(true)}
  >
    Party Details
  </button>
</div>}
                    {(RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.SHIPPING_DETAILS) && bookingsStore.current.contract?.shipmentType != SHIPMENT_TYPE.air) && <button
                        className="button is-link is-small"
                        onClick={() =>
                            configStore.shippingDetails = true
                        }>
                        Shipping Details
                    </button>}
                    {(RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.CONTAINER_DETAILS) && shipmentType.includes('fcl')) && <button
                        className="button is-link is-small"
                        onClick={() =>
                            configStore.containerDetails = true
                        }>
                        Container Details
                    </button>} 
                    {(RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.HBL_DETAILS) && bookingsStore.current.contract?.shipmentType != SHIPMENT_TYPE.air  && buttonCondition) ?
                            <button className="button is-link is-small"
                                onClick={(e) => {
                                    if(bookingsStore.current.erpBookingId){
                                        BookingsApi.getBooking(bookingsStore.current._id, (data) => {
                                            bookingsStore.current = data
                                            configStore.blDetails = true
                                        })
                                    }else{
                                        configStore.setModalMessage('Please update the HBL number')
                                    }
                                }}
                            >HBL</button> :<></>
                    }{
                        RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.SYNC_WITH_ERP)  &&
                            <button className="button is-link is-small"
                                disabled={!brec?.erpShipmentId}
                                onClick={(e) => {
                                    setChargesErpReq(true)
                                }}
                            >Charges - ERP</button>
                    }
                </div>

                    {invoiceReq && (
                        <div style={{
      top: '50px'}}>
        <InvoiceForm
        invoiceReq={invoiceReq}
          invoiceData={invoiceData}
          renderData={renderData}
          entityData={entityStore.entityRec}
          setInvoiceReq={setInvoiceReq}
          setInvoiceData={setInvoiceData}
          cecOc={cecOc}
          cecOd={cecOd}
        />
        </div>
      )}
                    {chargesErpReq && (
                        <div style={{
                            position: 'fixed',
                            inset: 0,
                            top: '50px',
                            background: '#fff',
                            zIndex: 1000,
                            display: 'flex',
                            flexDirection: 'column',
                        }}>
                            <div style={{
                                padding: '12px 16px',
                                borderBottom: '1px solid #ddd',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                background: '#f5f5f5',
                            }}>
                                <h3 style={{ margin: 0 }}>Charges - ERP</h3>
                                <button
                                    className="button is-small is-danger"
                                    onClick={() => {
                                        if (brec?.contract?.chargesErpState?.lastStatus === "PROCESSING") {
                                            AgmodalStore.pageVisible = false;
                                        }
                                        setChargesErpReq(false);
                                    }}
                                >
                                    X
                                </button>
                            </div>
                            <div style={{ flex: 1, overflowY: 'auto', padding: '16px' }}>
                                <ChargesErp brec={brec} />
                            </div>
                        </div>
                    )}
            <div>
                <h2 style={{ paddingTop: "10px", fontSize: "1rem", fontWeight: "bold" }}>Shipper / Exporter details {cecOc && !brec.flexiBooking && ' - invoicing'}</h2>

                {!brec.flexiBooking &&<div className="columns">
                    <$cr n='2'>First Name{space}</$cr>
                    <$c n='3'>
                        {renderData.shipperFirstName}
                    </$c>
                    <$cr n='2'>Last Name</$cr>
                    <$c n='3'>
                        {renderData.shipperLastName}
                    </$c>
                </div>}

                {!brec.flexiBooking &&<div className="columns">
                    <$cr n='2'>Email ID</$cr>
                    <$c n='3'>
                        {renderData.shipperEmail}
                    </$c>
                    <$cr n='2'>Contact Number</$cr>
                    <$c n='3'>
                        {renderData.shipperContact}
                    </$c>
                </div>}
                {cecOc && !brec.flexiBooking ?
                    <div className="columns">
                        <$cr n='2'>Branch</$cr>
                        <$c n='3'>
                            {/* {brec.branchId} */}
                            {branchName}
                        </$c>
                    </div> : null}
                <div className="columns">
                    <$cr n='2'>Shipper Name</$cr>
                    <$c n='3'>
                        {renderData.shipperName}
                    </$c>
                    <$cr n='2'>Address</$cr>
                    <$c n='3'>
                        {cecOc || brec.flexiBooking ?brec.shipperAddress ||  (!brec.flexiBooking && brec.address ): shipperDetails.address}
                    </$c>
                </div>
                {!cecOc && !brec.flexiBooking &&
                <div>
                <div className="columns">
                 <$cr n='2'>Send Milestone alerts ?</$cr>
                    <$c n='3'>
                        <input className={`checkbox`} type = 'checkbox' checked={brec.sendMilestoneAlert}
                        />
                    </$c>
                </div>
                {!brec.flexiBooking &&<div className="columns is-narrow">
                    <$cr n='2'>City</$cr>
                    <$c n='3'>
                        {shipperDetails.city}
                    </$c>
                    <$cr n='2'>State</$cr>
                    <$c n='3'>
                        {shipperDetails.state}
                    </$c>
                </div>}</div>
}
                {!brec.flexiBooking &&<div className="columns is-narrow">
                    <$cr n='2'>PIN/ZIP Code</$cr>
                    <$c n='3'>
                        {cecOc|| brec.flexiBooking ? brec.shipperPin || brec.pin : shipperDetails.pincode}
                    </$c>
                    <$cr n='2'>Country</$cr>
                    <$c n='3'>
                        {cecOc || brec.flexiBooking? brec.shipperCountry || brec.country : shipperDetails.country}
                    </$c>
                </div>}
                </div>
                {brec.flexiBooking || !(!cecOc && !cecOd) ?
                ((!((cecOc && !shipperDetails?.companyName)) || brec.flexiBooking) &&
                <div>
                    <h2 style={{ paddingTop: "10px", fontSize: "1rem", fontWeight: "bold" }}>Consignee / Importer details {cecOd && !brec.flexiBooking && ' - invoicing'}</h2>
                     {!brec.flexiBooking && <div><div className="columns">
                        <$cr n='2'>First Name{space}</$cr>
                        <$c n='3'>
                            {cecOd && !brec.flexiBooking ? brec.firstName : shipperDetails.firstName}
                        </$c>
                        <$cr n='2'>Last Name</$cr>
                        <$c n='3'>
                            {cecOd && !brec.flexiBooking ? brec.lastName : shipperDetails.lastName}
                        </$c>
                    </div>

                    <div className="columns">
                        <$cr n='2'>Email ID</$cr>
                        <$c n='3'>
                            {cecOd && !brec.flexiBooking ? brec.emailid : shipperDetails.emailId}
                        </$c>
                        <$cr n='2'>Contact Number</$cr>
                        <$c n='3'>
                            {cecOd && !brec.flexiBooking? brec.phone : shipperDetails.mobileNumber}
                        </$c>
                    </div>
                    {cecOd ?
                        <div className="columns">
                            <$cr n='2'>Branch</$cr>
                            <$c n='3'>
                                {/* {brec.branchId} */}
                                {branchName}
                            </$c>
                        </div> : null}</div>}
                    <div className="columns">
                        <$cr n='2'>Consignee Name</$cr>
                        <$c n='3'>
                            {cecOd && !brec.flexiBooking ? companyName || brec.company : shipperDetails.companyName}
                        </$c>
                        <$cr n='2'>Address</$cr>
                        <$c n='3'>
                            {cecOd && !brec.flexiBooking ? brec.address : shipperDetails.address}
                        </$c>
                    </div>
                    {!cecOd && !brec.flexiBooking &&
                    <div>
                    <div className="columns">
                     <$cr n='2'>Send Milestone alerts ?</$cr>
                        <$c n='3'>
                            <input className={`checkbox`} type = 'checkbox' checked={brec.sendMilestoneAlert}
                            />
                        </$c>
                    </div>
               {!brec.flexiBooking && <div className="columns is-narrow">
                    <$cr n='2'>City</$cr>
                    <$c n='3'>
                        {shipperDetails.city}
                    </$c>
                    <$cr n='2'>State</$cr>
                    <$c n='3'>
                        {shipperDetails.state}
                    </$c>
                </div>}</div>}
                    {!brec.flexiBooking &&<div className="columns is-narrow">
                        <$cr n='2'>PIN/ZIP Code</$cr>
                        <$c n='3'>
                            {cecOd ? brec.pin : shipperDetails.pincode}
                        </$c>
                        <$cr n='2'>Country</$cr>
                        <$c n='3'>
                            {cecOd ? brec.country : shipperDetails.country}
                        </$c>
                    </div>}
                </div>)
                : <div>
                <h2 style={{ paddingTop: "10px", fontSize: "1rem", fontWeight: "bold" }}>{!brec.flexiBooking ? 'Invoice' : 'Booking'} details</h2>
                {cecOd ?
                    <div className="columns">
                        <$cr n='2'>Branch</$cr>
                        <$c n='3'>
                            {/* {brec.branchId} */}
                            {branchName}
                        </$c>
                    </div> : null}
                <div className="columns">
                    <$cr n='2'>Shipper Name</$cr>
                    <$c n='3'>
                        {companyName}
                    </$c>
                    <$cr n='2'>Address</$cr>
                    <$c n='3'>
                        {brec.address}
                    </$c>
                </div>
                <div className="columns is-narrow">
                    <$cr n='2'>PIN/ZIP Code</$cr>
                    <$c n='3'>
                        {brec.pin}
                    </$c>
                    <$cr n='2'>Country</$cr>
                    <$c n='3'>
                        {brec.country}
                    </$c>
                </div>
            </div>}
            </div>
            {brec.flexiBooking && (
  <div>
    <h2 style={{ paddingTop: "10px", fontSize: "1rem", fontWeight: "bold" }}>
      Booking details
    </h2>

    <div className="columns">
 <$cr n="2">Entity Name</$cr>
      <$c n="3">
        {companyName}
      </$c> 

    </div>
{
    (TenantUtils.isNavexel())?<div className="columns">     
 <$cr n="2">Relationship Manager</$cr>
      <$c n="3">
        {(EntityV2Store?.EntityRec?.customer!=undefined)? rmemails[0]?.email:""}
      </$c>    
       <$cr n="2">Customer Service</$cr>
      <$c n="3">
        {(EntityV2Store?.EntityRec?.customer!=undefined)?csemails[0]?.email:""}
      </$c>
    </div>:""
}

    <div className="columns">
     
            <$cr n="2">Branch</$cr>
      <$c n="3">
        {branchName}
      </$c>
      <$cr n="2">Address</$cr>
      <$c n="3">
        {brec.address}
      </$c>
    </div>
  </div>
)}
            <div>
                <h2 style={{ paddingTop: "10px", fontSize: "1rem", fontWeight: "bold" }}>Shipment details</h2>
                <div className="columns is-narrow">
                    <$cr n="2">
                        Freight?
                    </$cr>
                    {brec.paymentType &&
                    <$c n="3">
                        {brec.paymentType} 
                    </$c>}
                    {
                        brec.etd_at_pol && 
                        <>
                            <$cr n='2'>ETD @ POL</$cr>
                            <$c n='3'>
                                {brec.etd_at_pol}
                            </$c>
                        </>
                    }
                    
                </div>
                <div className="columns">
                    <$cr n='2'>Incoterms</$cr>
                    <$c n='3'>
                        {brec.incoTerms}
                    </$c>
                    <$cr n='2'>Commodity Type</$cr>
                    <$c n='3'>
                        {brec.commodityType}
                    </$c>
                </div>
                <div className="columns">
                    {selectedItems.length ?(
                <>
                    <$cr n= '2'>HSN Code</$cr>
                    <$c n='3'>
                        <div
                            className="selected-tags"
                            style={{
                                display: "flex",
                                flexWrap: "wrap", 
                                gap: "5px",
                                width: "100%", 
                                maxWidth: "100%", 
                                overflow: "hidden",
                                boxSizing: "border-box",
                            }}
                            >
                            {selectedItems.map((item) => (
                                <div
                                key={item.id}
                                className="tag"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    background: "#e0e0e0",
                                    borderRadius: "20px",
                                    fontSize: "14px",
                                    padding: "8px 12px", 
                                    maxWidth: "200px", 
                                    whiteSpace: "nowrap", 
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    boxSizing: "border-box",
                                    justifyContent: "flex-start",
                                }}
                                title={`${item.commodityDescription} (${item.commodityTypeName})`} // Tooltip for full text
                                >
                                <span style={{ flex: "1" }}>
                                    {item.commodityDescription} ({item.commodityTypeName})
                                </span>
                                </div>
                            ))} 
                        </div>
                    </$c>
                </>):<></>}
                {brec.blType && (<>
                <$cr n='2'>BL Type</$cr>
                <$c n='6'>
                    {brec.blType}
                </$c></>)}
                </div>
                <div className="columns">
                    {
                        brec.carrierMBL && 
                        <>
                            <$cr n='2'>Carrier MBL</$cr>
                            <$c n='3'>
                                {brec.carrierMBL}
                            </$c>
                        </>
                    }
                    {
                        brec.shipperPDA &&
                        <>
                            <$cr n='2'>ShipperPDA</$cr>
                            <$c n='3'>
                                {brec.shipperPDA}
                            </$c>
                        </>
                    }
                    
                </div>
                {/* <div className="columns is-narrow">
                    <$cr n='2'>FBA</$cr>
                    <$c n='2'>
                        <Agyesno disabled={true} label='' record={brec} name='fba' />
                    </$c>
                    <$c n='8'>
                    </$c>
                </div> */}
                <div className="columns is-narrow">
                    <$cr n='2'>Special Instructions</$cr>
                    <$c n='6'>
                        {brec.specialInstructions}
                    </$c>
                </div>
                <h2 style={{ paddingTop: "10px", fontSize: "1rem", fontWeight: "bold" }}>Cargo Value</h2>
                            <div className="columns">
                    {
                        (cargovalsave)?<>
                        <$cr n='2'>Currency</$cr>
                                    <$c n='3'>
                                        
                                                <div className="control">
                                                    <div className={`select`}>
                                                        <select
                                                            className={`select is-fullwidth is-small`}
                                                            value={cargovalcur}
                                                            onChange={(e) => {
                                                                setCargovalcur(e.target.value)
                                                            }}
                                                        >
                                                            {configStore.getCurrencyList().map((e) => (
                                                                <option key={e} value={e}>
                                                                    {e}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                
                                    </$c>
                                <$cr n='2'>Amount</$cr>
                                    <$c n='3'>
                                        <input class="input is-small" className={`input is-small`} value={cargoval} type="number"
                                                onChange={(e)=>{
                                                    setCargoval(e.target.value.trim())
                                                }} />
                
                                    </$c>
                                    {(cargoval.trim().length>0 && Utils.toNum(cargoval.trim())>0)?<>
                                    <button className="button is-success"
              onClick={async () => {
                let ret = await MonApi.apost(UPDATE_BOOKING_FIELDS_URI, {
  _id: bookingsStore.current._id,
  cargovalcur: cargovalcur,
  cargoval: cargoval
})
                brec.cargovalcur = cargovalcur
                brec.cargoval = cargoval
                setCargovalsave(false)
             }}>
             save
         </button>
                                    </>:<></>}
                        </>:<>
                        <$cr n='2'>Currency</$cr>
                                    <$c n='3'>
                                               {brec.cargovalcur}
                                    </$c>
                                <$cr n='2'>Amount</$cr>
                                    <$c n='3'>
                                        {brec.cargoval}
                
                                    </$c>
                        </>
                    }
                </div>
                {/* <div className="field has-addons" >
                                                    <p className="control">
                                                        <span style={{ paddingTop: "10px", fontSize: "1rem", fontWeight: "bold" }}>Shipping Bill No</span>
                                                        <button className="button is-success is-inverted" style={{paddingTop:"0px"}}
                                                            onClick={() => {
                                                                configStore.shippingbillmodal=true
                                                            }}>
                                                            <span className="icon is-small">
                                                                <i className="fas fa-plus"></i>
                                                            </span>
                                                        </button>
                                                    </p>
                                                </div>
                                                {(bookingsStore.current.shippingBillNo!=undefined && bookingsStore.current.shippingBillNo.length>0) && <div className="columns">
                                
                                <div class="column is-12">
                                    {bookingsStore.current.shippingBillNo.join(', ')}
                                </div>
                                
                            </div>} */}
                            
            {
                (brec.fba=='Yes'  && fbaDetails!=undefined && fbaDetails.length>0)? <>
                <h2 style={{ paddingTop: "10px", fontSize: "1rem", fontWeight: "bold" }}>FC</h2>
                    {brec.contract?.warehouse === 'AMAZON' && (<div className="columns is-narrow">    
                        <$cr n='2'>Merchant ID</$cr>
                        <$c n='3'>
                            <input className={`input is-small ${faberror.indexOf("merchantID")!=-1?"is-danger":""}`} value={merchantID}
                                onChange={(e)=>{
                                    setMerchantID(Utils.removeSpecialCharacters(e.target.value.trim(),14))
                                }}
                                //onBlur={()=>{setFbaupdatecheck(fbaupdatecheck+1)}}
                            />
                        </$c>
                    </div>)}
                    {
                        fbaDetails!=undefined && fbaDetails.length>0 && fbaDetails.map((k,i)=>{
                            return <>
                            {
                                brec.fbaDetails.length>1?<div className="columns is-narrow">    
                                <$cr n='2'><h2 style={{ paddingTop: "10px", fontSize: "0.7rem", fontWeight: "bold" }}>Destination {i+1}</h2></$cr>
                            </div>:""
                            }
                            {
                                k.map((e,j)=>{
                                    return <><div className="columns is-narrow">   
                                    <$cr n='2'>FC ID</$cr>
                                    <$c n='3'>
                                            <input class="input is-small" className={`input is-small ${faberror.indexOf("fbaID"+i+j)!=-1?"is-danger":""}`} value={fbaDetails[i][j].fbaID}
                                                onChange={(e)=>{
                                                    let f = fbaDetails
                                                    f[i][j].fbaID=e.target.value.trim()
                                                    setFbaDetails(JSON.parse(JSON.stringify(f)))
                                                }}
                                                // onBlur={()=>{setFbaupdatecheck(fbaupdatecheck+1)}}
                                            />
                                    </$c>
                                    {
                                    brec.contract?.warehouse === 'AMAZON' ? (<>
                                        <$cr n='2'>Amazon Reference ID</$cr>
                                        <$c n='3'>
                                            <input className={`input is-small ${faberror.indexOf("purchaseOrderID"+i+j)!=-1?"is-danger":""}`} value={fbaDetails[i][j].purchaseOrderID}
                                                onChange={(e)=>{
                                                    let f = fbaDetails
                                                    f[i][j].purchaseOrderID=Utils.removeSpecialCharacters(e.target.value.trim(),8)
                                                    setFbaDetails(JSON.parse(JSON.stringify(f)))
                                                }}
                                                // onBlur={()=>{setFbaupdatecheck(fbaupdatecheck+1)}}
                                                //onBlur={BookingsApi.setcustrefBooking(bookingsStore.current._id,brec.fbaDetails,brec.merchantID)}
                                            />
                                        </$c>
                                    </>) : <></>}
                                    
                                    </div>
                                    <div className="columns is-narrow">  
                                    <$cr n='2'>PO Issuance Date</$cr>
                                    <$c n='3'>
                                        <input className={`input is-small ${faberror.indexOf("poExpiryDate"+i+j)!=-1?"is-danger":""}`} type="date" value={fbaDetails[i][j].poExpiryDate==undefined?"":fbaDetails[i][j].poExpiryDate}
                                            onChange={(e)=>{
                                                let f = fbaDetails
                                                f[i][j].poExpiryDate=e.target.value
                                                setFbaDetails(JSON.parse(JSON.stringify(f)))
                                            }}
                                            // onBlur={()=>{setFbaupdatecheck(fbaupdatecheck+1)}}
                                            //onBlur={BookingsApi.setcustrefBooking(bookingsStore.current._id,brec.fbaDetails,brec.merchantID)}
                                        />
                                    </$c>
                                    
                                    <$cr n='5'>
                                    <p className="control" style={{textAlign:"right"}}>
            {
              (k.length!=1)?<button className="button is-danger"
              onClick={(e) => {
                delfba(i,j,fbaDetails) 
             }}>
             <span className="icon is-small">
                 <i className="fas fa-trash"></i>
             </span>
         </button>:""
            }
          &nbsp;
          {
            (k.length-1==j)?
            <button className="button is-success"
                                                                   onClick={(e) => {
                                                                    let f = JSON.parse(JSON.stringify(fbaDetails))
                                                                    f[i].push({fbaID : "", purchaseOrderID : ""})
                                                                    setFbaDetails(JSON.parse(JSON.stringify(f)))
                                                                    //updatefba(f,false)
                                                                  }}>
                                                                  <span className="icon is-small">
                                                                      <i className="fas fa-plus"></i>
                                                                  </span>
                                                              </button>:""
          }
          
          </p>
                                    </$cr>
                                </div>
                                </>
                                })
                            }
                            
                            </>
                        })
                    }
                    {(brec.merchantID!=merchantID || JSON.stringify(fbaDetails)!=JSON.stringify(brec.fbaDetails))?
                    <div className="columns is-narrow">    
                    <$cr n='10'></$cr>
                    <$c n='2'>
                    <p className="control" >
          <button className="button" style={{textAlign:"right", backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON, color: "#fff", }}
          onClick={(e) => {
            setFbaupdatecheck(fbaupdatecheck+1)
         }}>save
     </button></p>
                    </$c>
                </div>:""}
                    
                </>:<></>
            }

            </div>
            {
                enterpriseCheck ?<div className="columns">
                <$c n='1'></$c>
                <$c n='9'>
                    <div className="table-container ">
                        <table className="table is-fullwidth is-bordered is-striped is-narrow is-hoverable ">
                            <thead>
                                <tr>
                                    <th style={{ width: '16rem' }}>Required Documents</th>
                                    <th>Document Uploaded</th>
                                    {enterpriseCheck?<th></th>:""}
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    enterpriseCheck?<><tr id="cwf1">
                                        <td>CI Upload</td>
                                        <td >
                                                {data?.commercialInvoiceList?.map(renderLink).map((link,i) => <><p>{link}
                                                    {
                                                        (!brec.commercialInvoiceList.includes(data?.commercialInvoiceList[i]))?
                                                        <span className="icon has-text-danger" style={{cursor: 'pointer'}} onClick={() => removeKey('commercialInvoiceList',i)}>
                                                            <i className="fas fa-trash"></i>
                                                        </span>
                                                        :<></>
                                                    }
                                                </p><br /></>)}
                                            </td>
                                            <td>    
                                                <AgCustomFile source='carrierwebform' cat={filecat} filetype='ci' parent="cwf1" multi={true}
                                                    callback={(filename) => updateKey('commercialInvoiceList',filename)} withBtn={data.commercialInvoiceList?.length>0} />
                                            </td>
                                        </tr></>:<></>
                                }
                                {
                                    enterpriseCheck?<><tr id="cwf2">
                                        <td>PL Upload</td>
                                        <td >
                                                {data?.packingList?.map(renderLink).map((link,i) => <><p>{link}
                                                    {
                                                        (!brec.packingList.includes(data?.packingList[i]))?
                                                        <span className="icon has-text-danger" style={{cursor: 'pointer'}} onClick={() => removeKey('packingList',i)}>
                                                            <i className="fas fa-trash"></i>
                                                        </span>
                                                        :<></>
                                                    }
                                                </p><br /></>)}
                                            </td>
                                            <td>    
                                                <AgCustomFile source='carrierwebform' cat={filecat} filetype='pl' parent="cwf2" multi={true}
                                                    callback={(filename) => updateKey('packingList',filename)} withBtn={data.packingList?.length>0} />
                                            </td>
                                        </tr></>:<></>
                                }
                                {
                                    (enterpriseCheck)?<><tr id="cwf14">
                                        <td>Shipping Intructions ({stype()})</td>
                                        <td >
                                                {data?.shippingInstructionList?.map(renderLink).map((link,i) => <><p>{link}
                                                    {
                                                        (!brec.shippingInstructionList.includes(data?.shippingInstructionList[i]))?
                                                        <span className="icon has-text-danger" style={{cursor: 'pointer'}} onClick={() =>removeKey('shippingInstructionList',i)}>
                                                            <i className="fas fa-trash"></i>
                                                        </span>:<></>}</p><br /></>)}
                                            </td>
                                            <td>    
                                                <AgCustomFile source='carrierwebform' cat={filecat} filetype='shippingInstruction' parent="cwf14" multi={true}
                                                    callback={(filename) => updateKey('shippingInstructionList',filename)} withBtn={data.shippingInstructionList?.length > 0} />
                                            </td>
                                        </tr></>:<></>
                                }
                                 {
                                    (enterpriseCheck && stype()=='FCL')?<><tr id="cwf3">
                                        <td>Carrier Release Order</td>
                                        <td >
                                                {data?.carrierReleaseOrderList?.map(renderLink).map((link,i) => <><p>{link}
                                                    {
                                                        (!brec.carrierReleaseOrderList.includes(data?.carrierReleaseOrderList[i]))?
                                                        <span className="icon has-text-danger" style={{cursor: 'pointer'}} onClick={() => removeKey("carrierReleaseOrderList",i)}>
                                                            <i className="fas fa-trash"></i>
                                                        </span>
                                                    :<></>}   
                                                </p><br /></>)}
                                            </td>
                                            <td>    
                                                <AgCustomFile source='carrierwebform' cat={filecat} filetype='cro' parent="cwf3" multi={true}
                                                    callback={(filename) => updateKey('carrierReleaseOrderList',filename)} withBtn={data.carrierReleaseOrderList?.length > 0} />
                                            </td>
                                        </tr></>:<></>
                                }
                                 {
                                    (enterpriseCheck && stype()!='AIR')?<><tr id="cwf4">
                                        <td>BL Draft</td>
                                        <td >
                                                {data?.blDraftList?.map(renderLink).map((link,i) => <><p>{link}
                                                    {
                                                        (!brec.blDraftList.includes(data?.blDraftList[i]))?
                                                        <span className="icon has-text-danger" style={{cursor: 'pointer'}} onClick={() => removeKey('blDraftList',i)}>
                                                            <i className="fas fa-trash"></i>
                                                        </span>
                                                        :<></>}
                                                </p><br /></>)}
                                            </td>
                                            <td>    
                                                <AgCustomFile source='carrierwebform' cat={filecat} filetype='BLDraft' parent="cwf4" multi={true}
                                                    callback={(filename) => updateKey('blDraftList',filename)} withBtn={data.blDraftList?.length > 0} />
                                            </td>
                                        </tr></>:<></>
                                }
                                 {
                                    (enterpriseCheck && stype()=='AIR')?<><tr id="cwf5">
                                        <td>AWB Draft</td>
                                        <td >
                                                {data?.awbDraftList?.map(renderLink).map((link,i) => <><p>{link}
                                                    {
                                                        (!brec.awbDraftList.includes(data?.awbDraftList[i]))?
                                                        <span className="icon has-text-danger" style={{cursor: 'pointer'}} onClick={() => removeKey('awbDraftList',i)}>
                                                            <i className="fas fa-trash"></i>
                                                        </span>
                                                        :<></>}
                                                </p><br /></>)}
                                            </td>
                                            <td>    
                                                <AgCustomFile source='carrierwebform' cat={filecat} filetype='AWBDraft' parent="cwf5" multi={true}
                                                    callback={(filename) => updateKey('awbDraftList',filename)} withBtn={data.awbDraftList?.length > 0} />
                                            </td>
                                        </tr></>:<></>
                                }
                                 {
                                    (enterpriseCheck && stype()!='AIR')?<><tr id="cwf6">
                                        <td>Final BL</td>
                                        <td >
                                                {data?.finalBlList?.map(renderLink).map((link,i) => <><p>{link}
                                                    {
                                                        (!brec.finalBlList.includes(data?.finalBlList[i]))?
                                                        <span className="icon has-text-danger" style={{cursor: 'pointer'}} onClick={() => removeKey('finalBlList',i)}>
                                                            <i className="fas fa-trash"></i>
                                                        </span>
                                                    :<></>}
                                                </p><br /></>)}
                                            </td>
                                            <td>    
                                                <AgCustomFile source='carrierwebform' cat={filecat} filetype='finalBL' parent="cwf6" multi={true}
                                                    callback={(filename) => updateKey('finalBlList',filename)} withBtn={data.finalBlList?.length > 0} />
                                            </td>
                                        </tr></>:<></>
                                }
                                 {
                                    (enterpriseCheck && stype()=='AIR')?<><tr id="cwf7">
                                        <td>Final AWB</td>
                                        <td >
                                                {data?.finalAWBList?.map(renderLink).map((link,i) => <><p>{link}
                                                    {
                                                        (!brec.finalAWBList.includes(data?.finalAWBList[i]))?
                                                        <span className="icon has-text-danger" style={{cursor: 'pointer'}} onClick={() => removeKey('finalAWBList',i)}>
                                                            <i className="fas fa-trash"></i>
                                                        </span>:<></>}</p><br /></>)}
                                            </td>
                                            <td>    
                                                <AgCustomFile source='carrierwebform' cat={filecat} filetype='finalAWB' parent="cwf7" multi={true}
                                                    callback={(filename) => updateKey('finalAWBList',filename)} withBtn={data.finalAWBList?.length > 0} />
                                            </td>
                                        </tr></>:<></>
                                }
                                 {
                                    enterpriseCheck?<><tr id="cwf8">
                                        <td>Freight Invoice</td>
                                        <td >
                                                {data?.freightInvoiceList?.map(renderLink).map((link,i) => <><p>{link}
                                                    {
                                                        (!brec.freightInvoiceList.includes(data?.freightInvoiceList[i]))?
                                                        <span className="icon has-text-danger" style={{cursor: 'pointer'}} onClick={() =>removeKey('freightInvoiceList',i)}>
                                                            <i className="fas fa-trash"></i>
                                                        </span>:<></>}</p><br /></>)}
                                            </td>
                                            <td>    
                                                <AgCustomFile source='carrierwebform' cat={filecat} filetype='freightInvoice' parent="cwf8" multi={true}
                                                    callback={(filename) => updateKey('freightInvoiceList',filename)} withBtn={data.freightInvoiceList?.length > 0} />
                                            </td>
                                        </tr></>:<></>
                                }
                                 {
                                    enterpriseCheck?<><tr id="cwf9">
                                        <td>Customs Duties & Taxes</td>
                                        <td >
                                                {data?.customsTaxesDutiesList?.map(renderLink).map((link,i) => <><p>{link}
                                                    {
                                                        (!brec.customsTaxesDutiesList.includes(data?.customsTaxesDutiesList[i]))?
                                                        <span className="icon has-text-danger" style={{cursor: 'pointer'}} onClick={() =>removeKey('customsTaxesDutiesList',i)}>
                                                            <i className="fas fa-trash"></i>
                                                        </span>:<></>}</p><br /></>)}
                                            </td>
                                            <td>    
                                                <AgCustomFile source='carrierwebform' cat={filecat} filetype='customsDuties' parent="cwf9" multi={true}
                                                    callback={(filename) => updateKey('customsTaxesDutiesList',filename)} withBtn={data.customsTaxesDutiesList?.length > 0} />
                                            </td>
                                        </tr></>:<></>
                                }
                                 {
                                    enterpriseCheck?<><tr id="cwf10">
                                        <td>Local Charges Invoice</td>
                                        <td >
                                                {data?.localChargesInvoiceList?.map(renderLink).map((link,i) => <><p>{link}
                                                    {
                                                        (!brec.localChargesInvoiceList.includes(data?.localChargesInvoiceList[i]))?
                                                        <span className="icon has-text-danger" style={{cursor: 'pointer'}} onClick={() =>removeKey('localChargesInvoiceList',i)}>
                                                            <i className="fas fa-trash"></i>
                                                        </span>:<></>}</p><br /></>)}
                                            </td>
                                            <td>    
                                                <AgCustomFile source='carrierwebform' cat={filecat} filetype='localChargeInvoice' parent="cwf10" multi={true}
                                                    callback={(filename) => updateKey('localChargesInvoiceList',filename)} withBtn={data.localChargesInvoiceList?.length > 0} />
                                            </td>
                                        </tr></>:<></>
                                }
                                 {
                                    (enterpriseCheck && brec?.contract?.shipmentScope?.split('-')[2]=='Door')?<><tr id="cwf11">
                                        <td>POD</td>
                                        <td >
                                                {data?.podList?.map(renderLink).map((link,i) => <><p>{link}
                                                    {
                                                        (!brec.podList.includes(data?.podList[i]))?
                                                        <span className="icon has-text-danger" style={{cursor: 'pointer'}} onClick={() =>removeKey('podList',i)}>
                                                            <i className="fas fa-trash"></i>
                                                        </span>:<></>}</p><br /></>)}
                                            </td>
                                            <td>    
                                                <AgCustomFile source='carrierwebform' cat={filecat} filetype='pod' parent="cwf11" multi={true}
                                                    callback={(filename) => updateKey('podList',filename)} withBtn={data.podList?.length > 0} />
                                            </td>
                                        </tr></>:<></>
                                }
                                 {
                                    (EntityV2Store.EntityRec.entityCountry !== bookingsStore.current.originCount && enterpriseCheck)?<><tr id="cwf12">
                                        <td>Delivery Order</td>
                                        <td >
                                                {data?.deliveryOrderList?.map(renderLink).map((link,i) => <><p>{link}
                                                    {
                                                        (!brec.deliveryOrderList.includes(data?.deliveryOrderList[i]))?
                                                        <span className="icon has-text-danger" style={{cursor: 'pointer'}} onClick={() =>removeKey('deliveryOrderList',i)}>
                                                            <i className="fas fa-trash"></i>
                                                        </span>:<></>}</p><br /></>)}
                                            </td>
                                            <td>    
                                                <AgCustomFile source='carrierwebform' cat={filecat} filetype='deliveryOrder' parent="cwf12" multi={true}
                                                    callback={(filename) => updateKey('deliveryOrderList',filename)} withBtn={data.deliveryOrderList?.length > 0} />
                                            </td>
                                        </tr></>:<></>
                                }
                                 {
                                    (enterpriseCheck && stype()=='LCL')?<><tr id="cwf13">
                                        <td>Measurement Slip</td>
                                        <td >
                                                {data?.measurementSlipList?.map(renderLink).map((link,i) => <><p>{link}
                                                    {
                                                        (!brec.measurementSlipList.includes(data?.measurementSlipList[i]))?
                                                        <span className="icon has-text-danger" style={{cursor: 'pointer'}} onClick={() =>removeKey('measurementSlipList',i)}>
                                                            <i className="fas fa-trash"></i>
                                                        </span>:<></>}</p><br /></>)}
                                            </td>
                                            <td>    
                                                <AgCustomFile source='carrierwebform' cat={filecat} filetype='measurementSlip' parent="cwf13" multi={true}
                                                    callback={(filename) => updateKey('measurementSlipList',filename)} withBtn={data.measurementSlipList?.length > 0} />
                                            </td>
                                        </tr></>:<></>
                                }
                                    {enterpriseCheck && carrierDocumentRows.map(({ id, label, key, filetype }) => (
                                        <tr id={id} key={id}>
                                            <td>{label}</td>
                                            <td>
                                                {data?.[key]?.map(renderLink).map((link, i) => <Fragment key={`${key}-${i}`}><p>{link}
                                                    {!(brec[key] || []).includes(data[key][i]) &&
                                                        <span className="icon has-text-danger" style={{ cursor: 'pointer' }} onClick={() => removeKey(key, i)}>
                                                            <i className="fas fa-trash"></i>
                                                        </span>}
                                                    </p><br /></Fragment>)}
                                            </td>
                                            <td>
                                                <AgCustomFile source='carrierwebform' cat={filecat} filetype={filetype} parent={id} multi={true}
                                                    callback={(filename) => updateKey(key, filename)} withBtn={data[key]?.length > 0} />
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                        {enterpriseCheck?<button className="button is-link float-end" onClick={(e)=>{
                            configStore.bookingModal = true
                        }}>Save</button>:<></>}
                    </div>
                </$c>
            </div>:<></>
            }
            
            <div className="columns">
                <$c n='1'></$c>
                <$c n='9'>
                    <div className="table-container ">
                        <table className="table is-fullwidth is-bordered is-striped is-narrow is-hoverable ">
                            <thead>
                                <tr>
                                    <th style={{ width: '16rem' }}>Required Documents</th>
                                    <th>Document Uploaded</th>
                                    {enterpriseCheck?<th></th>:""}
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    bookingsStore.current?.commercialInvoice_filename_list?.length > 0 && (<tr>
                                        <td>Commercial Invoice</td>
                                        <td>{brec.commercialInvoice_filename_list.map(renderLink).map(link => <>{link}<br /></>)}</td>
                                    </tr>)
                                }
                                {
                                    bookingsStore.current?.packingList_filename_list?.length > 0 &&
                                    <tr>
                                        <td>Packing List</td>
                                        <td>{brec.packingList_filename_list.map(renderLink).map(link => <>{link}<br /></>)}</td>
                                    </tr>
                                }
                                {
                                    bookingsStore.current?.specialInstructions_filename_list?.length > 0 &&
                                    <tr>
                                        <td>Special Instructions</td>
                                        <td>{brec.specialInstructions_filename_list.map(renderLink).map(link => <>{link}<br /></>)}</td>
                                    </tr>
                                }
                                {
                                    bookingsStore.current?.custbookingconf_filename_list?.length > 0 &&
                                    <tr>
                                        <td>Customer Booking Confirmation</td>
                                        <td>{brec.custbookingconf_filename_list.map(renderLink).map(link => <>{link}<br /></>)}</td>
                                    </tr>
                                }
                                {
                                    (
                                        (brec.commodityType && brec.commodityType.startsWith('Non-Hazardous Chemicals'))
                                        || (brec.contract.hazardous === 'Yes')
                                    ) ?
                                        <tr>
                                            <td>MSDS</td>
                                            <td>{renderLink(brec.msds_filename)}</td>
                                        </tr>
                                        : <></>
                                }
                                {
                                    (brec.commodityType && brec.commodityType.startsWith('Non-Hazardous Chemicals')) ?
                                        <tr>
                                            <td>Non-DG Declaration</td>
                                            <td>{renderLink(brec.nondgdecl_filename)}</td>
                                        </tr> : <></>
                                }
                                {
                                    (brec.contract.hazardous === 'Yes') ?
                                        <>
                                            <tr>
                                                <td>DG Declaration</td>
                                                <td>{renderLink(brec.dgdecl_filename)}</td>
                                            </tr>
                                            <tr>
                                                <td>IIP Certificate</td>
                                                <td>{renderLink(brec.iipcert_filename)}</td>
                                            </tr>
                                        </> : <></>
                                }
                                {
                                    bookingsStore.current?.shippingBill_filename_list?.length > 0 &&
                                    <tr>
                                        <td>Shipping Bill</td>
                                        <td>{brec.shippingBill_filename_list.map(renderLink).map(link => <>{link}<br /></>)}</td>
                                        {enterpriseCheck ? <td></td> : null}
                                    </tr>
                                }
                                {
                                    bookingsStore.current?.cartingPhotos_filename_list?.length > 0 &&
                                    <tr>
                                        <td>Carting photos</td>
                                        <td>{brec.cartingPhotos_filename_list.map(renderLink).map(link => <>{link}<br /></>)}</td>
                                    </tr>
                                }
                                {
                                    bookingsStore.current?.mmSlip_filename_list?.length > 0 &&
                                    <tr>
                                        <td>MM Slip</td>
                                        <td>{brec.mmSlip_filename_list.map(renderLink).map(link => <>{link}<br /></>)}</td>
                                    </tr>
                                }
                                {
                                    bookingsStore.current?.shippingBillchecklist_filename_list?.length > 0 &&
                                    <tr>
                                        <td>Shipping Bill CheckList</td>
                                        <td>{brec.shippingBillchecklist_filename_list.map(renderLink).map(link => <>{link}<br /></>)}</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </$c>
            </div>

        </div>
    )
}


function ProceedPopup({ data,bookingNum }) {
  let modalClass = "modal";
  if (configStore.bookingModal) modalClass += " is-active";
  return (
    <div className={modalClass}>
      <div className="modal-background"></div>
      <div
        className="modal-card"
        onClick={(e) => {
          e.stopPropagation();
        }}
        style={{ borderRadius: "10px", width: "900px" }}
      >
        <section className="modal-card-body">
          <Cols>
            <Col8
              style={{color: "darkblue","margin-left": "150px","font-size": "25px",}}>
            Are you sure you want to save the documents   
             </Col8>
          </Cols>
          <br />
          <button
            class="button is-danger"
            style={{ float: "right" }}
            onClick={async () => {
             const uploads = {
                "commercialInvoiceList": data.commercialInvoiceList,
                "packingList":data.packingList,
                "carrierReleaseOrderList":data.carrierReleaseOrderList,
                "blDraftList":data.blDraftList,
                "finalAWBList":data.finalAWBList,
                "awbDraftList":data.awbDraftList,
                "finalBlList":data.finalBlList,
                "freightInvoiceList":data.freightInvoiceList,
                "customsTaxesDutiesList":data.customsTaxesDutiesList,
                "localChargesInvoiceList":data.localChargesInvoiceList,
                "podList":data.podList,
                "deliveryOrderList":data.deliveryOrderList,
                "measurementSlipList":data.measurementSlipList,
                "shippingInstructionList":data.shippingInstructionList,
                "carrierDraftList": data.carrierDraftList,
                "carrierFinalList": data.carrierFinalList,
                "carrierInvoicesList": data.carrierInvoicesList,
                "vendorInvoicesList": data.vendorInvoicesList,
                "supportingsList": data.supportingsList,
                "shippingBill_filename_list": data.shippingBill_filename_list
             }
             await MonApi.apost(UPDATE_BOOKING_DATA_BY_ID_URI, {
  _id: bookingNum,
  updateData: uploads
})
             configStore.bookingModal = false;
             AgmodalStore.pageVisible = false
             }}>
            Submit
          </button>
          <button
            class="button is-warning"
            onClick={() => {
              configStore.bookingModal = false;
            }}
          >
            Cancel
          </button>
        </section>
      </div>
    </div>
  );
}


